import React from "react";
import { Col, Row, Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import IconList from "../assets/images/icon-list.png";
import { MapPin } from "react-feather";
import { Mail } from "react-feather";
import { Phone } from "react-feather";
import { Facebook } from "react-feather";
import { Twitter } from "react-feather";
import { Youtube } from "react-feather";
import AndriodBtn from "../assets/images/android-btn.png";
import AppleBtn from "../assets/images/apple.png";

const Footer = () => {
  const footerNavigate = useNavigate();
  return (
    <>
      <section className="padTop50">
        <div className="footerTop">
          <Container>
            <Row>
              <Col xs={12} lg={12} xl={5} className="changeOrder">
                <div className="footerBlockFirst">
                  <p>Rewards Connect</p>
                  <p>
                    Adani RewardsConnect is an application build for the Adani
                    Unified Loyalty program named RewardsHub, designed to
                    acknowledge, strengthen, and enhance our relationship with
                    our loyal partners. Adani Cement's relationship with our
                    Channel Partners and Influencers is a matter of Pride for
                    Adani Cement and this program is an effort by us to help
                    them grow their business with us as well as ensure better
                    benefits for them for their loyalty to us.
                  </p>
                  <p className="mt-3 footer-btnTitle">
                    Download Rewards Connect App
                  </p>
                  <div className="footerBtnBox">
                    <a href="https://play.google.com/store/apps/details?id=com.adanicementtw" target="_blank">
                      <div className="footerBtnBoxWrap">
                        <img
                          src={AndriodBtn}
                          alt="image"
                          className="img-fluid"
                        />
                      </div>
                    </a>
                    <div className="footerBtnBoxWrap">
                      <a href="https://apps.apple.com/in/app/rewards-connect-adani/id6480509076" target="_blank">
                        <img src={AppleBtn} alt="image" className="img-fluid" />
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={12} lg={4} xl={2} className="changeOrderTop">
                <div className="footerBlockList">
                  <p>Quick Links</p>
                  <ul>
                    <li>
                      <Link to="/rewards-category-list">
                        {" "}
                        <img src={IconList} alt="iconList" />
                        Rewards Categories
                      </Link>
                    </li>
                    <li>
                      <Link to="/program-details">
                        {" "}
                        <img src={IconList} alt="iconList" />
                        Program Details
                      </Link>
                    </li>
                    <li>
                      <Link to="/faqs">
                        {" "}
                        <img src={IconList} alt="iconList" />
                        FAQs
                      </Link>
                    </li>
                    {/* <li>
                                            <Link to = '/gallery'> <img src={IconList} alt='iconList'/> Gallery</Link>
                                        </li>
                                        <li>
                                            <Link to = '/newsletter'> <img src={IconList} alt='iconList'/>Newsletter</Link>
                                        </li> */}
                  </ul>
                </div>
              </Col>
              <Col xs={12} lg={4} xl={2} className="changeOrderTop">
                <div className="footerBlockList">
                  <p>My Profile</p>
                  <ul>
                    {/* <li>
                                            <Link to = "/profile"><img src={IconList} alt='iconList'/>My Profile</Link>
                                        </li> */}
                    <li>
                      <Link to="/my-point-statement">
                        <img src={IconList} alt="iconList" />
                        My Points
                      </Link>
                    </li>
                    <li>
                      <Link to="/my-orders">
                        <img src={IconList} alt="iconList" />
                        My Orders
                      </Link>
                    </li>
                    {/* <li>
                                            <Link to = '/'> <img src={IconList} alt='iconList'/>My Activity</Link>
                                        </li> */}
                  </ul>
                </div>
              </Col>
              <Col xs={12} lg={4} xl={3} className="changeOrderTop">
                <div className="footerBlockList">
                  <p>Quick Contact</p>
                  <ul>
                    <li>
                      <Link>
                        {" "}
                        <MapPin /> Address will show here
                      </Link>
                    </li>
                    <li>
                      <Link>
                        {" "}
                        <Phone /> Toll Free No: +91-8088-919-885
                      </Link>
                    </li>
                    <li>
                      <Link>
                        {" "}
                        <Mail /> Email: support@demo.com
                      </Link>
                    </li>
                  </ul>
                  <div className="footerBottomLinkSocial">
                    {/* <ul>
                      <li>
                        <Link>
                          <Facebook />
                        </Link>
                      </li>
                      <li>
                        <Link>
                          <Twitter />
                        </Link>
                      </li>
                      <li>
                        <Link>
                          <Youtube />
                        </Link>
                      </li>
                    </ul> */}
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="footerBottom">
          <Container>
            <Row>
              <Col xs={12} lg={6}>
                <p className="copyRightTxt">
                  © Copyright 2024 Rewards Connect . All Rights Reserved.{" "}
                </p>
              </Col>
              <Col xs={12} lg={6}>
                <div className="footerBottomLink">
                  <ul>
                    <li>
                      <Link to="/terms">Terms & Condition</Link>
                    </li>
                    <li>
                      <Link to="/faqs">FAQs</Link>
                    </li>
                    <li>
                      <Link to="/helpdesk">Help Desk</Link>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    </>
  );
};

export default Footer;
